var map = {
	"./board-basic/view.vue": [
		"e34d",
		"chunk-2d225094"
	],
	"./board-notice/view.vue": [
		"c4c0",
		"chunk-4ab2d4ac"
	],
	"./board-question/view.vue": [
		"3a83",
		"chunk-2d0c42ff"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "9152e";
module.exports = webpackAsyncContext;